$('.h-menu__open').on('click', function(){
  $('.h-menu').addClass('h-menu__show');
});
$('.h-menu__close').on('click', function(){
  $('.h-menu').removeClass('h-menu__show');
});

$('.search-open').on('click', function(){
  $('.header-search__sp').toggleClass('active');
});

$('.dots-slider__item').on('click', function(){
  $(this).addClass('is-active');
  $('.dots-slider__item').not(this).removeClass('is-active');

  var index = $(this).index();
  $('.thumbnail-slider__item').removeClass('is-active');
  $('.thumbnail-slider__item').eq(index).addClass('is-active');
});

$(function(){
  var header__height = $('header').innerHeight();
  var pos = 0;
  var header = $('.header-search__sp');

  $(window).on('scroll', function(){
    var current_pos = $(this).scrollTop();
    if( current_pos >= pos && current_pos > 50){
      header.addClass('hide');
    } else {
      header.removeClass('hide');
    }
    pos = current_pos;
  });
});

$('.product__slider').slick({
  prevArrow: '<div class="slick-prev"></div>',
  nextArrow: '<div class="slick-next"></div>',
  dots:true,
  customPaging: function(slick,index) {
    // スライダーのインデックス番号に対応した画像のsrcを取得
    let targetImage = slick.$slides.eq(index).find('img').attr('src');
    // slick-dots > li　の中に上記で取得した画像を設定
    return '<img src=" ' + targetImage + ' "/>';
  }
});

$(function ($) {
  $(".accordion-btn").click(function () {
    $(".accordion-btn").not(this).removeClass("open");
    $(".accordion-btn").not(this).next().slideUp(300);
    $(this).toggleClass("open");
    $(this).next().slideToggle(300);
  });
});

$(function(){
  if(window.matchMedia("(max-width: 480px)").matches){
    $(".category__list").css("display", "none");
    $(".accordion-btn--sp").click(function () {
      $(".accordion-btn--sp").not(this).removeClass("open");
      $(".accordion-btn--sp").not(this).next().slideUp(300);
      $(this).toggleClass("open");
      $(this).next().slideToggle(300);
    });
  }
});

function tabGethashID (tabhashIDName){
	if(tabhashIDName){
		//タブ設定
		$('.h-menu-tab li').find('a').each(function() { //タブ内のaタグ全てを取得
			var tabidName = $(this).attr('href'); //タブ内のaタグのリンク名（例）#lunchの値を取得	
			if(tabidName == tabhashIDName){ //リンク元の指定されたURLのハッシュタグ（例）http://example.com/#lunch←この#の値とタブ内のリンク名（例）#lunchが同じかをチェック
				var tabparentElm = $(this).parent(); //タブ内のaタグの親要素（li）を取得
				$('.h-menu-tab li').removeClass("active"); //タブ内のliについているactiveクラスを取り除き
				$(tabparentElm).addClass("active"); //リンク元の指定されたURLのハッシュタグとタブ内のリンク名が同じであれば、liにactiveクラスを追加
				//表示させるエリア設定
				$(".h-menu-tab__item").removeClass("show"); //もともとついているis-activeクラスを取り除き
				$(tabhashIDName).addClass("show"); //表示させたいエリアのタブリンク名をクリックしたら、表示エリアにis-activeクラスを追加	
			}
		});
	}
}

//タブをクリックしたら
$('.h-menu-tab a').on('click', function() {
	var tabidName = $(this).attr('href'); //タブ内のリンク名を取得	
	tabGethashID (tabidName);//設定したタブの読み込みと
	return false;//aタグを無効にする
});


// 上記の動きをページが読み込まれたらすぐに動かす
$(window).on('load', function () {
    $('.h-menu-tab li:first-of-type').addClass("active"); //最初のliにactiveクラスを追加
    $('.h-menu-tab__item:first-of-type').addClass("show"); //最初の.areaにis-activeクラスを追加
	var tabhashName = location.hash; //リンク元の指定されたURLのハッシュタグを取得
	tabGethashID (tabhashName);//設定したタブの読み込み
});

function GethashID (hashIDName){
	if(hashIDName){
		//タブ設定
		$('.tab__panel li').find('a').each(function() { //タブ内のaタグ全てを取得
			var idName = $(this).attr('href'); //タブ内のaタグのリンク名（例）#lunchの値を取得	
			if(idName == hashIDName){ //リンク元の指定されたURLのハッシュタグ（例）http://example.com/#lunch←この#の値とタブ内のリンク名（例）#lunchが同じかをチェック
				var parentElm = $(this).parent(); //タブ内のaタグの親要素（li）を取得
				$('.tab__panel li').removeClass("active"); //タブ内のliについているactiveクラスを取り除き
				$(parentElm).addClass("active"); //リンク元の指定されたURLのハッシュタグとタブ内のリンク名が同じであれば、liにactiveクラスを追加
				//表示させるエリア設定
				$(".tab__content").removeClass("show"); //もともとついているis-activeクラスを取り除き
				$(hashIDName).addClass("show"); //表示させたいエリアのタブリンク名をクリックしたら、表示エリアにis-activeクラスを追加	
			}
		});
	}
}

//タブをクリックしたら
$('.tab__panel a').on('click', function() {
	var idName = $(this).attr('href'); //タブ内のリンク名を取得	
	GethashID (idName);//設定したタブの読み込みと
	return false;//aタグを無効にする
});


// 上記の動きをページが読み込まれたらすぐに動かす
$(window).on('load', function () {
    $('.tab__panel li:first-of-type').addClass("active"); //最初のliにactiveクラスを追加
    $('.tab__content:first-of-type').addClass("show"); //最初の.areaにis-activeクラスを追加
	var hashName = location.hash; //リンク元の指定されたURLのハッシュタグを取得
	GethashID (hashName);//設定したタブの読み込み
});


document.addEventListener("DOMContentLoaded", function () {
  // タブに対してクリックイベントを適用
  const tabs = document.getElementsByClassName("js-tab");
  for (let i = 0; i < tabs.length; i++) {
    tabs[i].addEventListener("click", tabSwitch);
  }

  // タブをクリックすると実行する関数
  function tabSwitch() {
    // 引数で指定したセレクターと一致する直近の祖先要素を取得
    const ancestorEle = this.closest(".js-tab-panel");
    // タブのclassの値を変更
    const active_tab_classes = "active";
    const inactive_tab_classes = "no-active";
    ancestorEle
      .getElementsByClassName(active_tab_classes)[0]
      .classList.add(inactive_tab_classes);
    ancestorEle
      .getElementsByClassName(active_tab_classes)[0]
      .classList.remove(active_tab_classes);
    this.classList.add(active_tab_classes);
    this.classList.remove(inactive_tab_classes);

    // コンテンツのclassの値を変更
    const active_content_classes = "block";
    const inactive_content_classes = "hidden";
    const targetEle = ancestorEle.getElementsByClassName(
      active_content_classes
    )[0];
    targetEle.classList.remove(active_content_classes);
    targetEle.classList.add(inactive_content_classes);

    const groupTabs = ancestorEle.getElementsByClassName("js-tab");
    const arrayTabs = Array.prototype.slice.call(groupTabs);
    const index = arrayTabs.indexOf(this);
    const targetPanel = ancestorEle.getElementsByClassName("js-panel")[index];
    targetPanel.classList.add(active_content_classes);
    targetPanel.classList.remove(inactive_content_classes);
  }
});